import Vue from 'vue'
import AppCard from "./components/AppCard"
import AppIcon from "./components/AppIcon"
import AppOverlay from "./components/AppOverlay"
import AppCounter from "./components/AppCounter"

Vue.component('counter', AppCounter);
Vue.component('card', AppCard);
Vue.component('icon', AppIcon);
Vue.component('overlay', AppOverlay);
